import { render, staticRenderFns } from "./DataCrudTable.vue?vue&type=template&id=5ba61ca7&"
import script from "./DataCrudTable.vue?vue&type=script&lang=js&"
export * from "./DataCrudTable.vue?vue&type=script&lang=js&"
import style0 from "./DataCrudTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports